module.exports = __webpack_public_path__ + "assets/img/footer-blob-mid.846ae6c9.png";